import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, Grid, IconButton, makeStyles, Paper, Tooltip, Typography } from "@material-ui/core";
import { CustomTextField, DateTime } from "@totalsoft/rocket-webapp-components-deprecated";
import { useTranslation } from "react-i18next";
import { Autorenew, Search } from "@material-ui/icons";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import clientPageStyle from "features/client/styles";
import { getTenant } from "providers/TenantProvider";
import { countryCodeConstants } from "features/common/constants";
import { emptyString } from "constants/defaultValues";

const useStyles = makeStyles(clientPageStyle);

function SoleTraderFilters({ filterLens, onReset, onSearch, loading }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const countryIsIreland = getTenant().countryCode === countryCodeConstants.ireland;

  const searchConditionText = useMemo(() => {
    if (countryIsIreland) return t("Client.SoleTraderIrelandSearchMessage");
    return t("Client.SoleTraderUKSearchMessage");
  }, [t, countryIsIreland]);

  return (
    <Paper className={classes.filterStyle}>
      <Grid container spacing={2} justifyContent="space-between" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="h4">{searchConditionText}</Typography>
        </Grid>
        {!countryIsIreland && (
          <Grid item container spacing={2}>
            <Grid item xs={12} md={3}>
              <CustomTextField
                required
                fullWidth
                label={t("Client.FirstName")}
                value={(filterLens.firstName |> get) || emptyString}
                onChange={filterLens.firstName |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomTextField
                required
                fullWidth
                label={t("Client.LastName")}
                value={(filterLens.lastName |> get) || emptyString}
                onChange={filterLens.lastName |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DateTime
                disableToolbar={false}
                fullWidth
                required
                label={t("Client.BirthDate")}
                value={filterLens.birthDate |> get}
                onChange={filterLens.birthDate |> set}
              />
            </Grid>
          </Grid>
        )}
        <Grid item container spacing={2}>
          {!countryIsIreland && (
            <Grid item xs={12} md={3}>
              <CustomTextField
                required
                fullWidth
                label={t("Client.Email")}
                value={(filterLens.email |> get) || emptyString}
                onChange={filterLens.email |> set |> onTextBoxChange}
              />
            </Grid>
          )}
          <Grid item xs={12} md={countryIsIreland ? 9 : 6}>
            <CustomTextField
              required={countryIsIreland}
              fullWidth
              label={t("Client.PIN")}
              value={(filterLens.pin |> get) || emptyString}
              onChange={filterLens.pin |> set |> onTextBoxChange}
            />
          </Grid>
        </Grid>
        <Grid item container direction="row" justifyContent="flex-end" alignItems="center">
          <IconButton color="default" onClick={onReset} className={classes.marginRight}>
            <Tooltip title={t("General.ResetFilter")}>
              <Autorenew fontSize="small" />
            </Tooltip>
          </IconButton>
          <Button
            id="soleTrader_SearchBtn"
            right="true"
            variant="contained"
            color="primary"
            onClick={onSearch}
            endIcon={loading ? <CircularProgress size={20} color={"inherit"} /> : <Search />}
          >
            {t("General.Search")}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

SoleTraderFilters.propTypes = {
  filterLens: PropTypes.object.isRequired,
  onReset: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default SoleTraderFilters;
